import React, { useState, useEffect } from 'react';

import { Box, Image, Link } from '@chakra-ui/react';
import { Button, CheckCircleOutline, Download } from '@mesh.ai/rabbit';

import SlackLogoIcon from 'assets/assetsV1/illustrations/SlackLogoIcon.png';

import { endpoints } from 'constants/endpoints';
import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { getSlackAuthDetails } from 'services/plugins';

import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium, TextHeader2 } from 'uiToolkitV1/Typography';

import { GuideSection } from './guideSection';
import { InstallationSection } from './installationSection';
import LinkTeamWithChannel from './linkTeamWithChannel';
import { PluginFeatures } from './pluginFeatures';

const thirdPartyType = 'SLACK';

const Header = ({ isActivated, loading }) => (
  <Box display="flex" gap={3} alignItems="center">
    <Box p="20px">
      <Image src={SlackLogoIcon} boxSize="80px" />
    </Box>

    <Box display="flex" flexDir="column">
      <TextHeader2 mb={1} bold>
        Slack
      </TextHeader2>
      <TextBodyMedium color="text.g2" mb={3}>
        Get updates for any Mesh pod on a chosen Slack channel
      </TextBodyMedium>
      {!loading && !isActivated ? (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link href={loading ? '' : endpoints.plugins.slack.auth} target="_blank" rel="noreferrer">
          <Button disabled={loading} iconLeft={Download}>
            Install
          </Button>
        </Link>
      ) : (
        <Box display="flex" gap={1} justifyContent="start" alignItems="center">
          {!loading && <CheckCircleOutline fontSize="18px" color="#1A5724" />}
          <TextBodyMedium bold color="#1A5724">
            {loading ? 'Loading...' : 'Installed'}
          </TextBodyMedium>
        </Box>
      )}
    </Box>
  </Box>
);

const SlackPlugin = () => {
  const [isActivated, setIsActivated] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    getSlackAuthDetails()
      .then((res) => setIsActivated(true))
      .catch((err) => setIsActivated(false))
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: 'Company-settings-slack',
      },
    });
  }, []);

  return (
    <PaperWithShadow display="flex" p={4} flexDir="column" gap="12px">
      <Header isActivated={isActivated} loading={loading} />

      <GuideSection />

      {!loading && isActivated && <PluginFeatures thirdPartyType={thirdPartyType.toLowerCase()} />}
      {isActivated !== null && <LinkTeamWithChannel isActivated={isActivated} />}
      {!loading && !isActivated && <InstallationSection />}
    </PaperWithShadow>
  );
};

export default SlackPlugin;
